<template>
    <div class="my-2">
        <div class="flex">
            <color-picker v-model="line.color" :initial-color="line.color"></color-picker>
            <bar-thickness v-model="line.width" :initial-value="line.width"></bar-thickness>
            <select class="ml-4 form-control form-control-sm" v-model="line.dashStyle" name="dash-style">
                <option v-for="dash in dashTypes" :value="dash.value">{{ dash.label }}</option>
            </select>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import ColorPicker from '../ColorPicker';
import BarThickness from '../BarThickness';

const props = defineProps(['defaultValue']);

const emit = defineEmits(['update:modelValue']);

const line = ref({
    color: props.defaultValue.color,
    width: props.defaultValue.width,
    dashStyle: props.defaultValue.dashStyle
});

const dashTypes = [
    {
        label: 'Solid',
        value: 'Solid'
    },
    {
        label: 'Short Dash',
        value: 'ShortDash'
    },
    {
        label: 'Short Dot',
        value: 'ShortDot'
    },
    {
        label: 'Short Dash Dot',
        value: 'ShortDashDot'
    },
    {
        label: 'Short Dash Dot Dot',
        value: 'ShortDashDotDot'
    },
    {
        label: 'Dot',
        value: 'Dot'
    },
    {
        label: 'Dash',
        value: 'Dash'
    },
    {
        label: 'Long Dash',
        value: 'LongDash'
    },
    {
        label: 'Dash Dot',
        value: 'DashDot'
    },
    {
        label: 'Long Dash Dot',
        value: 'LongDashDot'
    }
];

watch(line, (newValue) => {
    emit('update:modelValue', newValue);
}, { deep: true });

watch(() => props.defaultValue, (newVal) => {
    line.value = {
        color: newVal.color,
        dashStyle: newVal.dashStyle,
        width: newVal.width
    };
}, { deep: true });
</script>
